import jwtDecode from 'jwt-decode'
import * as React from 'react'
import Error from '../apps/Error'

export const ExportToContext = React.createContext({})

export function ExportToProvider({ children }) {
  const [context, setContext] = React.useState()
  const [error, setError] = React.useState(false)

  React.useEffect(() => {
    const locationSearchParams = new URLSearchParams(window.location.search)
    const jiraToken = locationSearchParams.get('jwt')
    const jiraSourcePage = new URL(locationSearchParams.get('link'))
    const filter = jiraSourcePage.searchParams.get('filter')
    const jql = jiraSourcePage.searchParams.get('jql')
    const timeZone = locationSearchParams.get('timeZone')

    const initialContext = {
      aaid: jwtDecode(jiraToken).sub,
      filter,
      jql,
      jiraToken,
      jiraSourcePage,
      timeZone,
    }

    const offlineFileInfoUrl = new window.URL(`${window.location.origin}/v2/file/info`)

    offlineFileInfoUrl.searchParams.set('jwt', jiraToken)
    offlineFileInfoUrl.searchParams.set('jiraSourcePage', jiraSourcePage)
    offlineFileInfoUrl.searchParams.set('fileType', 'offline')
    offlineFileInfoUrl.searchParams.set('timeZone', timeZone)

    if (jql) {
      offlineFileInfoUrl.searchParams.set('jql', jql)
    }
    if (filter) {
      offlineFileInfoUrl.searchParams.set('filter', filter)
    }

    const onlineFileInfoUrl = new window.URL(offlineFileInfoUrl)

    onlineFileInfoUrl.searchParams.set('fileType', 'online')

    Promise.all([
      fetch(offlineFileInfoUrl).then((response) => response.json()),
      fetch(onlineFileInfoUrl).then((response) => response.json()),
    ])
      .then((infos) => {
        const [offlineFileInfo, onlineFileInfo] = infos

        initialContext.offlineFileInfo = offlineFileInfo
        initialContext.onlineFileInfo = onlineFileInfo
        setContext({ ...initialContext })
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(`Unable to fetch file info:`, e)
        setError(true)
      })
  }, [])

  return (
    <ExportToContext.Provider value={{ ...context }}>
      {error ? <Error /> : children}
    </ExportToContext.Provider>
  )
}
